import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, Flex } from '@chakra-ui/react';
import auth from '@udacity/ureact-hoth';

import { useUpdateMentorMutation } from 'app/mentor/queries/enhanced';
import TermsOfServiceCopy from 'app/common/components/terms-of-service/terms-of-service-copy';
import { useAppToast } from 'app/common/hooks/use-app-toast';

import CONFIG from 'configLoader';
import styles from './terms-of-service.module.scss';

export const TermsOfService: React.FC = () => {
  const uid = auth.getCurrentUserId();
  const [agreementVersion, setAgreementVersion] = useState<string | null>(null);
  const [updateMentor] = useUpdateMentorMutation();

  const { t } = useTranslation();
  const toast = useAppToast();
  const history = useHistory();
  let redirectTimer: NodeJS.Timer;

  useEffect(() => {
    return () => clearTimeout(redirectTimer);
  }, []);

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setAgreementVersion(CONFIG.latestAgreementVersion);
    } else {
      setAgreementVersion(null);
    }
  };

  const isFormComplete = useMemo(() => {
    const requiredFields = [uid, agreementVersion];

    return requiredFields.every((field) => {
      return !!field;
    });
  }, [uid, agreementVersion]);

  const handleSuccess = () => {
    redirectTimer = setTimeout(() => {
      history.push('/');
    }, 3000);

    toast({
      variant: 'success',
      description: t('termsOfService.thankYouForAgreeing'),
    });
  };

  const handleDoneClick = async () => {
    if (!uid || !agreementVersion) {
      return;
    }

    try {
      await updateMentor({ uid, agreement_version: agreementVersion }).unwrap();
      handleSuccess();
    } catch (e) {
      console.error(e);
      toast({
        variant: 'error',
        description: t('error.somethingWentWrong'),
      });
    }
  };

  return (
    <div className={styles.gradient}>
      <section className={styles.card}>
        <div>
          <TermsOfServiceCopy />
        </div>
        <Flex justify="space-between" align="center" py={6} px="5rem" borderTop="1px solid" borderTopColor="gray.200">
          <Checkbox id="tos-checkbox" onChange={handleCheck} isChecked={!!agreementVersion} alignItems="start">
            {t('termsOfService.iAgreeTo')}
          </Checkbox>
          <Button type="submit" onClick={handleDoneClick} isDisabled={!isFormComplete}>
            {t('common.submit')}
          </Button>
        </Flex>
      </section>
    </div>
  );
};
